(function ($) {
  $(document).on('contentFilter.updateContentHeight', function (event, $hoveredTout, isHover) {
    Drupal.behaviors.contentFilterSetToutV2.updateContentHeight($hoveredTout, isHover);
  });

  Drupal.behaviors.contentFilterSetToutV2 = {
    attached: false,
    nodes: {},
    selectors: {
      modules: '.js-content-filter-tout-v2',
      contentText: '.js-content-text',
      contentDescription: '.js-content-description-under-image',
      contentEyebrown: '.js-content-eyebrow-under-image',
    },
    isMobile: false,
    attach: function (context) {
      var self = this;
      var $modules = $(self.selectors.modules, context);

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.isMobile = Unison.fetch.now().name === 'small';

      $modules.each(function () {
        var $module = $(this);
        self.setup($module);
      });
    },
    setup: function ($module) {
      var self = this;
      
      self.getDom($module);
      self.setEvents($module);
    },
    getDom: function ($module) {
      var self = this;

      $module.nodes = {};
      $module.nodes.$contentText = $(self.selectors.contentText, $module);
    },
    setEvents: function ($module) {
      var self = this;
      
      Unison.on('change', function () {
        self.isMobile = Unison.fetch.now().name === 'small';
      });

      $module.once('content-filter-tout-hover').on('mouseover focusin', function () {
        var $hoveredTout = $(this);
        self.updateContentHeight($hoveredTout, true);
      }).on('mouseout focusout', function () {
        var $hoveredTout = $(this);
        self.updateContentHeight($hoveredTout, false);
      });
    },
    updateContentHeight: function ($hoveredTout, isHover) {
      var self = this;
      var $contentText = $hoveredTout.find(self.selectors.contentText);
      var $contentDescription = $hoveredTout.find(self.selectors.contentDescription);
      var $contentEyebrown = $hoveredTout.find(self.selectors.contentEyebrown);
      var offsetHeight;
      
      if (!self.isMobile && $contentText.length > 0 && $contentDescription.length > 0 && $contentEyebrown.length > 0) {
        if (isHover) {
          offsetHeight = $contentDescription.height() - ($hoveredTout.height() - $contentText.height());
          $hoveredTout.addClass('hover');
          $contentText.css('min-height', $contentText.height());
          $contentEyebrown.css('margin-top', `-${offsetHeight}px`);
        } else {
          $hoveredTout.removeClass('hover');
          $contentEyebrown.css('margin-top', '');
        }
      }
    },
  };
})(jQuery);
